var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcVolumeOffBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27024",
    d: "M15.735 12.479V6.464a.6.6 0 00-1.06-.375l-2.3 2.843",
    fill: "#006e94",
    stroke: "#006e94",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27025",
    d: "M10.507 11.25l-.853 1.058a.6.6 0 01-.465.222H5.223a.6.6 0 00-.6.6v6.252a.6.6 0 00.6.6h4.7a.6.6 0 01.463.222l.9 1.11 3.388 4.2a.6.6 0 001.059-.375v-9.236",
    fill: "#006e94",
    stroke: "#006e94",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27026",
    d: "M22.677 23.181a9.588 9.588 0 01-2.759 1.6",
    fill: "none",
    stroke: "#006e94",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27027",
    d: "M19.773 6.801a9.576 9.576 0 014.761 14.313",
    fill: "none",
    stroke: "#006e94",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27028",
    d: "M19.586 12.156a4.762 4.762 0 011.286 5.653",
    fill: "none",
    stroke: "#006e94",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1103",
    fill: "none",
    stroke: "#006e94",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M4.626 5.155l21.691 21.688"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 27054",
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.788 9.397l3.369 3.563.844-.387-3.495-4.083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.506 8.495L16 12.573l-.843.387-3.369-3.563.718-.902z",
    fill: "#006e94"
  }))));
}
export default SvgIcVolumeOffBlue;